import { IAllTagsQuery } from '@rhizome/pgtypes';
import { Tune } from '@styled-icons/material';
import TippyHeadless from '@tippyjs/react/headless';
import { setWidgets } from 'apps/exegesis/pages/notes/dashboard';
import {
  colors,
  DarkenMedium,
  DarkenSlightly,
} from 'apps/exegesis/styles/themes';
import { useFetcher } from 'apps/exegesis/utils/DataFetchers';
import { useAuthor } from 'apps/exegesis/utils/useAuthor';
import { usePrivacy } from 'apps/exegesis/utils/usePrivacy';
import { useState } from 'react';
import styled from 'styled-components';
import { CreateMentionSlateComponent } from '../SlateEditor/plugins/TagMentionSlateComponent';
import { TagMenu } from '../TagDisplay';
import { PinnedTagsWidgetProps, WidgetUtilityProps } from './WidgetWrapper';

const MentionComponent = CreateMentionSlateComponent(true);

export const PinnedTagsWidget = (
  props: PinnedTagsWidgetProps & WidgetUtilityProps
) => {
  const privacy = usePrivacy();
  const author = useAuthor((state) => state.author);
  const { data: allTags, status: tagStatus } = useFetcher<IAllTagsQuery>(
    [
      'AllTags',
      {
        tags: [],
        public: privacy === 'public',
        author: author || null,
      },
    ],
    { keepPreviousData: true }
  );
  const [showSettings, setShowSettings] = useState(false);
  const toggleSettings = () => {
    setShowSettings(!showSettings);
  };
  const closeSettings = () => {
    setShowSettings(false);
  };
  const [searchField, setSearchField] = useState('');

  const handleSearchFieldChange = (
    evt: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (evt.target !== null) setSearchField(evt.target.value);
  };

  return (
    <div>
      <TippyHeadless
        interactive={true}
        offset={[0, 0]}
        placement="bottom-start"
        visible={showSettings}
        arrow={false}
        onClickOutside={closeSettings}
        render={(attrs) => (
          <CustomTippy className="box" tabIndex={-1} {...attrs}>
            {allTags ? (
              <TagMenu
                tags={allTags}
                selectedTags={new Set(props.tags)}
                setSelectedTags={(newSet: Set<string>) => {
                  let newWidgets = [...props.widgets];
                  (newWidgets[props.index] as PinnedTagsWidgetProps).tags =
                    Array.from(newSet);
                  setWidgets(newWidgets);
                }}
                searchField={searchField}
                setSearchField={setSearchField}
                handleSearchFieldChange={handleSearchFieldChange}
              />
            ) : (
              <div>loading</div>
            )}
          </CustomTippy>
        )}
      >
        <TagSettingButton onClick={toggleSettings}>
          <Tune width="1.8rem" />
        </TagSettingButton>
      </TippyHeadless>
      {props?.tags?.map((tag, i) => {
        return (
          <StyledTag key={i}>
            <MentionComponent attributes={null} element={{ value: tag }} />
          </StyledTag>
        );
      })}

      {props?.tags?.length > 0 ? null : (
        <>
          <br />
          <i>{'[no tags pinned. press the button above to pin some tags]'}</i>
        </>
      )}
    </div>
  );
};

const StyledTag = styled.span`
  display: inline-block;

  margin: 0.5rem 0.5rem 0px 0px;
  & > span {
    font-size: 2.5rem;
  }
`;

const CustomTippy = styled.div`
  width: 250px;
  /* height: 250px; */
  -webkit-box-shadow: 1px 2px 14px -2px rgba(0, 0, 0, 0.15);
  box-shadow: 1px 2px 14px -2px rgba(0, 0, 0, 0.15);
  border: 1px solid ${colors.offBlack};
`;

export const TagSettingButton = styled.div`
  margin: 0.3rem 0.3rem 0px 0px;

  height: 1.8rem;
  width: 1.8rem;
  vertical-align: bottom;
  background-color: ${DarkenSlightly};
  :hover {
    background-color: ${DarkenMedium};
  }
`;
